import { useState, useEffect } from "react";
import { api } from "../utils/api";

export function usePrivileges() {
  const [state, setState] = useState({
    role: null,
    permissions: new Set(),
    isLoading: true,
  });

  useEffect(() => {
    api
      .get("/me")
      .then(({ role, permissions }) => {
        setState({ role, permissions: new Set(permissions), isLoading: false });
      })
      .catch(() => {
        setState({ role: "viewer", permissions: new Set(), isLoading: false });
      });
  }, []);

  return { ...state, can: (action) => state.permissions.has(action) };
}
